<section class="container-fluid">
  <div class="row justify-content-md-center m-top-100">
    <div class="col-12 text-center">
      <h1>404</h1>
      <h2 class="bold">{{"404.TITLE" | translate}}</h2>
      <p class="sub-title">{{"404.SUB_TITLE" | translate}}</p>
      <a routerLink="/" class="btn btn-teal btn-large">Back To RMS</a>
    </div>

  </div>
</section>
